/**
 * External dependencies
 */
import { get } from 'lodash';

export default (state, id) => get(state, ['paymentTypes', 'items', id], null);